import { render, staticRenderFns } from "./proposte.vue?vue&type=template&id=efb5c75e&scoped=true&"
import script from "./proposte.vue?vue&type=script&lang=js&"
export * from "./proposte.vue?vue&type=script&lang=js&"
import style0 from "./proposte.vue?vue&type=style&index=0&id=efb5c75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb5c75e",
  null
  
)

export default component.exports